var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource-item"},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.item === null)?_vm._t("loading",[_c('loading')]):_vm._t("item",null,{"item":_vm.item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }